export { default } from './UserChangeAvatarReportPop';



// WEBPACK FOOTER //
// ./src/components/UserAccount/UserChangeAvatarReportPop/index.js